import { config, handleResponse } from '../../_helpers';

export const sqServices = {
    getListOfSqForAe,
    getListOfSqForSm,
    getListOfSqForAud,
    getListOfSqForFA,
    getListOfArchieveSq,
    CreateSQWTerms,
    UpdateSqWTerms,
    deleteSqWTerms,
    getSqWTerms,
    getTermsByCargoType,
    updateSQStatus,
    addToArchive,
    generateCharges,

    searchCustSQViewer,
    readGroupSQ,

    sqReportsBooking,

    SqUpdates,

    getSqWTermsAmendedSqref,

    getListOfSqForSBM,

    getPresData,

    getOpenVan,

    deactivateSQ,

    // SQ Memorandum
    getListSQCharges,
    getCompanyPolicy,
    getListSQforMemo,
    proceedtoSQMemo,

    // Aging
    searchAe,
    searchCustomerperAe,
    agingReportAe,

    downloadAllSQperCustomer,

    sqExpiration,
    getListSQforExpiration,
    SQDeactivation,
    SQDeactivationLog,
};

function sqExpiration(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/sqExpiration`, requestOptions).then(handleResponse);
}

function getListSQforExpiration(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getListSQforExpiration`, requestOptions).then(handleResponse);
}


function SQDeactivation(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/SQDeactivation`, requestOptions).then(handleResponse);
}

function SQDeactivationLog(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/LoadDeactivationLog`, requestOptions).then(handleResponse);
}

function downloadAllSQperCustomer(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/downloadAllSQperCustomer`, requestOptions).then(handleResponse);
}

function getCompanyPolicy() {
    const requestOptions = {
        method: 'GET',
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getCompanyPolicy`, requestOptions).then(handleResponse);
}
function getListSQCharges() {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify({}),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getListSQCharges`, requestOptions).then(handleResponse);
}
function getListSQforMemo(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getListSQforMemo`, requestOptions).then(handleResponse);
}
function proceedtoSQMemo(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/SalesQuotations/proceedtoSQMemo`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/SalesQuotations/proceedtoSQMemoV1`, requestOptions).then(handleResponse);
}

function getOpenVan(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getOpenVan`, requestOptions).then(handleResponse);
}

//end
function getListOfSqForAe(UserId, DocumentStatus, skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    // if (filter && search) {
    //     return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAe?UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    // } else {
    //     return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAe?UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // }
    if (filter && search) {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAewithSBM?UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAewithSBM?UserId=${UserId}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
    } else {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAewithSBM?UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);            
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAewithSBM?UserId=${UserId}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
        }
    }
}
function getListOfSqForSBM(userBranch, UserId, DocumentStatus, skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSBM?userBranch=${userBranch}&UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSBM?userBranch=${userBranch}&UserId=${UserId}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
    } else {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSBM?userBranch=${userBranch}&UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSBM?userBranch=${userBranch}&UserId=${UserId}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
        }
    }
}
function getListOfSqForSm(userBranch, UserId, DocumentStatus, skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    // if (filter && search) {
    //     return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSm?userBranch=${userBranch}&UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    // } else {
    //     return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSm?userBranch=${userBranch}&UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    // }
    if (filter && search) {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSMWithSBM?userBranch=${userBranch}&UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);            
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSMWithSBM?userBranch=${userBranch}&UserId=${UserId}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
    } else {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSMWithSBM?userBranch=${userBranch}&UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForSMWithSBM?userBranch=${userBranch}&UserId=${UserId}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
        }
    }
}
function getListOfSqForAud(UserId, DocumentStatus, skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAud?UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAud?UserId=${UserId}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
    } else {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAud?UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForAud?UserId=${UserId}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
        }
    }
}
function getListOfSqForFA(UserId, DocumentStatus, skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForFA?UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForFA?UserId=${UserId}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
        }
    } else {
        if(DocumentStatus && DocumentStatus !== ''){
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForFA?UserId=${UserId}&DocumentStatus=${DocumentStatus}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);   
        }
        else{
            return fetch(`${config.apiUrl}/SalesQuotations/getListOfSqForFA?UserId=${UserId}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
        }
    }
}
function getListOfArchieveSq(UserId, skip, take, filter, search) {
    const requestOptions = {
        method: 'GET'
    };
    if (filter && search) {
        return fetch(`${config.apiUrl}/SalesQuotations/getListOfArchieveSq?UserId=${UserId}&skip=${skip}&take=${take}&filter=${filter}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/SalesQuotations/getListOfArchieveSq?UserId=${UserId}&skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function CreateSQWTerms(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/CreateSQWTerms`, requestOptions).then(handleResponse);
}
function UpdateSqWTerms(payload, ref) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/UpdateSqWTerms/${ref}`, requestOptions).then(handleResponse);
}
function deleteSqWTerms(id) {
    const requestOptions = {
        method: 'DELETE',
        body: JSON.stringify(id),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/deleteSqWTerms`, requestOptions).then(handleResponse);
}
function getSqWTerms(SQRefNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getSqWTerms/${SQRefNum}`, requestOptions).then(handleResponse);
}
function getSqWTermsAmendedSqref(SQRefNum) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getSqWTermsAmendedSqref/${SQRefNum}`, requestOptions).then(handleResponse);
}
function getTermsByCargoType(code, sqdate) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getTermsByCargoTypeCode?CargoTypeCode=${code}&sqDate=${sqdate}`, requestOptions).then(handleResponse);
}
function updateSQStatus(payload, ref, rowVersion) {
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // console.log(requestOptions.body)
    // return fetch(`${config.apiUrl}/SalesQuotations/updateSqStatus/${ref}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/SalesQuotations/updateSqStatusPerTotalRates/${ref}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/SalesQuotations/updateSqStatusWthSQAmended/${ref}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/SalesQuotations/updateSqStatusWthSBM/${ref}`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/SalesQuotations/updateSqStatusWthSBMV1/${ref}`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/SalesQuotations/updateSqStatusWthSBMV2/${ref}`, requestOptions).then(handleResponse);
}
function addToArchive(DateInput, UserId) {
    const requestOptions = {
        method: 'PUT'
    };
    return fetch(`${config.apiUrl}/SalesQuotations/addToArchive?Date=${DateInput}&UserId=${UserId}`, requestOptions).then(handleResponse);
}
function generateCharges(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/SalesQuotations/SQDocsDetails`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/SalesQuotations/SQDocsCharges`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/SalesQuotations/generateChargesQWithOpenVan`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/SalesQuotations/generateWithOpenVanSelection`, requestOptions).then(handleResponse);
    // return fetch(`${config.apiUrl}/SalesQuotations/generateWithOpenVanSelectionV1`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/SalesQuotations/generateChargeWithTandemRates`, requestOptions).then(handleResponse);
}
function searchCustSQViewer(customer) {
    const requestOptions = {
        method: 'GET'
    };
    return fetch(`${config.apiUrl}/SalesQuotations/searchCustSQViewer?company=${customer}`, requestOptions).then(handleResponse);
}
function readGroupSQ(payload, skip, take, search) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    if (search) {
        return fetch(`${config.apiUrl}/SalesQuotations/readGroupSQ?skip=${skip}&take=${take}&search=${search}`, requestOptions).then(handleResponse);
    } else {
        return fetch(`${config.apiUrl}/SalesQuotations/readGroupSQ?skip=${skip}&take=${take}`, requestOptions).then(handleResponse);
    }
}
function sqReportsBooking(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/sqReportsBooking`, requestOptions).then(handleResponse);
}

function SqUpdates(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/SQAmended`, requestOptions).then(handleResponse);
}

function getPresData(Data) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(Data),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/getPresData`, requestOptions).then(handleResponse);
}

function deactivateSQ(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    return fetch(`${config.apiUrl}/SalesQuotations/deactivateSQ`, requestOptions).then(handleResponse);
}

// Aging
function searchAe(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Reports/searchAe`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Reports/searchAeV1`, requestOptions).then(handleResponse);
}
function searchCustomerperAe(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Reports/searchCustomerperAe`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Reports/searchCustomerperAeV1`, requestOptions).then(handleResponse);
}
function agingReportAe(payload) {
    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    };
    // return fetch(`${config.apiUrl}/Reports/agingReportAe`, requestOptions).then(handleResponse);
    return fetch(`${config.apiUrl}/Reports/agingReportAeV1`, requestOptions).then(handleResponse);
}